module.exports = __webpack_public_path__ + "static/media/biorific-solution.4cb2facc.png";